import { AccessPointLogService } from './AccessPointLogService';
import { AresService } from './AresService';
import { VisitationService } from './VisitationService';
import { WorkplaceService } from './WorkplaceService';
import { CompanyService } from './CompanyService';
import { DashboardTileService } from './DashboardTileService';
import { InvitationVisitService } from './InvitationVisitService';
import { InvitationService } from './InvitationService';
import { InvitationPersonService } from './InvitationPersonService';
import { EntryRequestService } from './EntryRequestService';
import { CompanySettingsService } from './CompanySettingsService';
import { SupplierCarService } from './SupplierCarService';
import { ActivityService } from './ActivityService';
import { ApplicationInvitationService } from './ApplicationInvitationService';
import { CertificateService } from './CertificateService';
import { CertificateTypeService } from './CertificateTypeService';
import { CodeListService } from './CodeListService';
import { EmployeeService } from './EmployeeService';
import { EstablishmentService } from './EstablishmentService';
import { SupplierService } from './SupplierService';
import { SupplierEmployeeService } from './SupplierEmployeeService';
import { TrainingService } from './TrainingService';
import { TrainingVersionService } from './TrainingVersionService';
import { QuestionnaireService } from './QuestionnaireService';
import { QuestionnaireVersionService } from './QuestionnaireVersionService';
import { UserService } from './UserService';
import { VisitationAnalyticsService } from './VisitationAnalyticsService';
import { WorkplaceHandoverService } from './WorkplaceHandoverService';

export const accessPointLogService = new AccessPointLogService();
export const aresService = new AresService();
export const visitationService = new VisitationService();
export const workplaceService = new WorkplaceService();
export const companyService = new CompanyService();
export const dashboardTileService = new DashboardTileService();
export const invitationVisitService = new InvitationVisitService();
export const invitationService = new InvitationService();
export const invitationPersonService = new InvitationPersonService();
export const entryRequestService = new EntryRequestService();
export const companySettingsService = new CompanySettingsService();
export const supplierCarService = new SupplierCarService();
export const activityService = new ActivityService();
export const applicationInvitationService = new ApplicationInvitationService();
export const certificateService = new CertificateService();
export const certificateTypeService = new CertificateTypeService();
export const codeListService = new CodeListService();
export const employeeService = new EmployeeService();
export const establishmentService = new EstablishmentService();
export const supplierService = new SupplierService();
export const supplierEmployeeService = new SupplierEmployeeService();
export const trainingService = new TrainingService();
export const trainingVersionService = new TrainingVersionService();
export const questionnaireService = new QuestionnaireService();
export const questionnaireVersionService = new QuestionnaireVersionService();
export const userService = new UserService();
export const visitationAnalyticsService = new VisitationAnalyticsService();
export const workplaceHandoverService = new WorkplaceHandoverService();